import { render, staticRenderFns } from "./UpdateFootfall.vue?vue&type=template&id=48ce657e&"
import script from "./UpdateFootfall.vue?vue&type=script&lang=js&"
export * from "./UpdateFootfall.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFootfall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports